import React, { Component } from 'react';
import './map.css';

export default class Map extends Component {

  constructor(props) {
    super(props);
    this.state = {
      latitude: 59.436962,
      longitude: 24.753574
    }
  }
  componentWillMount() {
    console.log('MAP will mount');
    let latitude = sessionStorage.getItem("latitude");
    let longitude = sessionStorage.getItem("longitude");
    if(latitude) {
      this.setState({ latitude: parseFloat(latitude) });
    }
    if(longitude) {
      this.setState({ longitude: parseFloat(longitude) });
    }
  }
  componentDidMount() {
    this.renderMap();
  }
  renderMap = () => {
    console.log('MAP rendering');
    load('https://maps.googleapis.com/maps/api/js?key=AIzaSyDp5k3r3XU5G1d9vlQ1t3dCFEjNDtbPDOI&callback=initMap');
    window.initMap = this.initMap;
  }
  initMap = () => {
    console.log('MAP init', this.state);
    var map = new window.google.maps.Map(document.getElementById("map"), {
      center : { lat: this.state.latitude, lng: this.state.longitude },
      zoom : 11
    });

    var centerMarker = new window.google.maps.Marker({
      position: map.getCenter(),
      map: map,
      title: 'Your location'
    });

    map.addListener('center_changed', () => {
      let position = map.getCenter();
      centerMarker.setPosition(position);

      this.props.onLocationChange({
        latitude: position.lat().toFixed(5),
        longitude: position.lng().toFixed(5)
      });
    });
  }

  render() {
    console.log('MAP render', this.state);
    return (
      <div id="map"></div>
    )
  }
}

function load(url) {
  console.log('load funk');
  let script = window.document.createElement("script");
  script.src = url;
  script.async = true;
  script.defer = true;

  window.document.getElementsByTagName("body")[0].appendChild(script);
}



// WEBPACK FOOTER //
// ./src/components/map.jsx